import { formatDate } from '../../../libs/date';
import { parseError } from '../../../libs/parser';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CommonDescription from '../../../components/CommonDescription';
import Context from '../../../provider';
import CustomerSelectComponent from '../../../components/CustomerSelectComponent';
import HeaderBarComponent from '../../../components/HeaderBarComponent';
import IconHKDC from '../../../assets/hkdc/icons/HKDCIcon';
import IconNews from '../../../assets/hkdc/icons/NewsIcon';
import IconNewsNone from '../../../assets/hkdc/icons/NoneNewsIcon';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import MobileLogoFooterComponent from '../../../components/LogoFooterComponent';
import React, { useContext, useEffect, useRef, useState } from 'react';
import config from '../../../config';
import memberApi from '../../../libs/api/memberApi';
import useIsScrolling from '../../../hooks/useIsScrolling';
import useNotificationsCount from '../../../hooks/useNotificationsCount';
import './index.scss';

const sortOptions = [
  { label: 'default', value: 'default' },
  { label: 'last-updated', value: 'newest_to_oldest' }
];

export default function MobileNews() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const notificationNotReadCount = useNotificationsCount();

  const scrollRef = useRef();
  const isScrolling = useIsScrolling(scrollRef.current);

  const { init, dispatch, lang, me } = useContext(Context);

  const [sortOption, setSortOption] = useState('default');
  const [newsData, setNewsData] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageData, setPageData] = useState(null);

  const fetchNewsData = async (page, sortType) => {
    try {
      dispatch({ type: 'SET_BACKDROP_LOADING', payload: true });
      const response = await memberApi.getNews({
        page,
        pageSize: 5,
        sort: sortType
      });
      setHasMore(response['has_next'] ?? false);
      setNewsData((prevData) => [...prevData, ...(response?.list ?? []).filter((d) => !(prevData.find((p) => p.uri_name === d.uri_name)))]);
    } catch (error) {
      dispatch({
        type: 'SET_ERROR_DIALOG',
        payload: { open: true, ...parseError(error) }
      });
    } finally {
      dispatch({ type: 'SET_BACKDROP_LOADING', payload: false });
    }
  };

  const fetchDescData = async () => {
    try {
      const page = await memberApi.getPage({ ruri: 'news-header' });
      setPageData(page);
    } catch (error) {
    }
  };

  // This page only allow logged in user
  useEffect(() => {
    if (init) {
      fetchNewsData(currentPage, sortOption);
      fetchDescData();
    }
  }, [init, currentPage]);

  useEffect(() => {
    setNewsData([]);
    if (currentPage > 1) {
      setCurrentPage(1);
    } else {
      fetchNewsData(1, sortOption);
    }
  }, [sortOption]);

  return (
    (
      <div className='mobile-news-page'>
        <HeaderBarComponent
          homeIcon={
            <IconHKDC
              style={{ width: '5rem', height: '2.78rem' }}
              onClick={(e) => {
                e.stopPropagation();
                window.location.assign('https://www.hkdesigncentre.org/ ');
              }}
            />
          }
        />
        <div ref={scrollRef} className="y-overflow content-container">
          <div className="title-icon-container">
            <div className="icon-container">
              <IconNews
                className="icon"
                size="large" />
            </div>
            <div className="news-titles-container">
              <div className="title">
                {pageData?.sections[0].title[lang] ?? ''}
              </div>
              <div className="desc">
                <CommonDescription data={pageData?.sections[0].content[lang] ?? ''} />
              </div>
            </div>
          </div>

          <div className="sort-container">
            <CustomerSelectComponent
              title={t('news.sort')}
              value={sortOption}
              options={sortOptions}
              isMobile={true}
              selectChange={(value) => {
                setSortOption(value);
              }}
            />
          </div>

          <div className="list-section">
            {
              newsData.length > 0 &&
              <div className="list-cont">
                {
                  newsData.map((item, index) => {
                    return (
                      <div key={index} className='item' onClick={() => {
                        if (item.external_url && item.external_url[lang]) {
                          window.location.assign(item.external_url[lang]);
                        } else {
                          navigate(`${config.basename}news-detail/${item.id}`, {
                            state: {
                              id: item.id
                            }
                          });
                        }
                      }}>
                          <div className='item-img' style={{ backgroundImage: `url(${item.cover[lang]})` }} />
                          <div className='item-content'>
                            <div className='item-text-time'>
                              {formatDate(item.updated_at, lang)}
                            </div>
                            <div className='item-text-title'>
                              {item.title[lang]}
                            </div>
                          </div>
                      </div>
                    );
                  })
                }
              </div>
            }
            {
              newsData.length === 0 &&
              <div className="none">
                <div className="title-cont">
                  <IconNewsNone
                    className='icon'
                    size="large" />
                  <div className="title-text">
                    {t('none-data.all-news-title')}
                  </div>
                </div>
                <div className="desc">
                  {t('none-data.all-news-desc')}
                </div>
              </div>
            }
            {
              hasMore && (
                <div
                  className="more-container"
                  onClick={(e) => {
                    e.stopPropagation();
                    setCurrentPage((prevCurrentPage) => prevCurrentPage + 1);
                  }}
                >
                  <div className="more-text">
                    MORE
                  </div>
                  <KeyboardArrowRightIcon
                    className="icon"
                    size="large" />
                </div>
              )
            }

          </div>
          <MobileLogoFooterComponent />
          <div style={{ height: '10rem', backgroundColor: '#000000' }} />
        </div>
      </div>
    )
  );
}